<marv-drawer #drawerStoresList (onDidDismiss)="this.onDidDismissDrawerStoresList($event)">
    <app-store-list (onSelectStore)="this.onSelectStore($event)"/>
</marv-drawer>

<marv-drawer #drawerStore size="big" (onDidDismiss)="this.onDidDismissDrawerStore($event)">
    @if(this.storeItem){
        <app-store-details [storeId]="this.storeItem.id" [tabSelected]="this.storeDetailsTab" [showDetailsMission]="false"/>
    }
</marv-drawer>

<ion-modal #modalDatesPreview
    class="modal modal_dates_preview"    
    [canDismiss]="this.canDismissDatesPreviewModal.bind(this)"
    (didDismiss)="this.onDidDismissDatesPreviewModal($event)" 
    >   
    <ng-template>
        <ion-content class="no_padding" scroll-y="false">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.closeDatesPreviewModal()"></ion-icon>
            </div>
            <app-dates-preview [datesPreview]="this.datesPreview" [dateMin]="this.startPlannableDate" [dateMax]="this.endPlannableDate" [editable]="!this.disabledForm" (onChangeDates)="this.onChangeDatesPreview($event)"/>
        </ion-content>
    </ng-template>
</ion-modal>

<ion-modal #modalAdditionalsDatas
    class="modal modal_additionals_datas"
    [canDismiss]="this.canDismissAdditionalsDatasModal.bind(this)"
    (didDismiss)="this.onDidDismissAdditionalsDatasModal($event)" 
    >   
    <ng-template>
        <ion-content class="ion-padding">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.closeAdditionalsDatasModal()"></ion-icon>
            </div>
            @if(this.operation && this.storeItem){
                <app-mission-additional-data [operationId]="this.operation.id" [data]="this.additionalsDatas" [canEdit]="true" (onChangeAdditionalsDatas)="this.onChangeAdditionalsDatas($event)"/>
            }
        </ion-content>
    </ng-template>
</ion-modal>

<form id="add_order_day" [formGroup]="this.addOrderDayForm" (ngSubmit)="this.saveOrderDay()">
    
    @if(this.isFetchingSave){
        <div id="bloc_fetching_save">
            <ion-spinner></ion-spinner>
        </div>        
    }
    
    <div id="add_order_day_content">

        @if(this.orderPlanningRules.length > 0){
            <marv-message type="info">
                {{'MSG_ORDER_PLANNING_RULES' | translate}} :
                @for(rule of this.orderPlanningRules; track $index){
                    <br> - {{rule}}
                }
            </marv-message>
        }
        
        <div class="order_title">
            <marv-section-title label="{{'STORE' | translate}}" icon="storefront-outline"/>
            @if(!this.disabledUpdate && !this.disabledForm){
                <marv-button icon="storefront-outline" [rounded]="true" (click)="this.openStoresDrawer()" /> 
            }
        </div>
        @if(this.isFetchingStore){
            <div class="bloc_loading">
                <ion-spinner></ion-spinner>
            </div>        
        }
        @else{
            @if(this.storeItem){
                <app-store-item 
                    [store]="this.storeItem" 
                    [operationId]="this.operation?.id"
                    [displayNbInterventions]="true" 
                    [displaySector]="true" 
                    [displayQuota]="false"  
                    [displayBtnRemoveStore]="!this.disabledUpdate && !this.disabledForm" 
                    (onRemoveStore)="this.unselectStore($event)"
                    (click)="this.openStoreDrawer()"
                />
               
                @if(this.displayAdditionalsDatas){
                    <div class="additionals_datas_status">
                        <marv-section-title label="{{'ADDITIONAL_DATA' | translate}}" icon="information-circle-outline"/>
                                           
                        <div class="additionals_datas_status_value">
                            @if(this.lastModificationAdditionalsDatas !== null){
                                {{'DATE_LAST_MODIFICATION' | translate}} : {{this.lastModificationAdditionalsDatas | marvDateToString: 'DD/MM/YYYY HH:mm'}}
                                <marv-button icon="eye-outline" [rounded]="true" size="small" (click)="this.showAdditionalsDatasStore()" /> 
                            }
                            @else{
                                <marv-message type="info">{{'MSG_NO_ADDITIONAL_DATA_VALUES' | translate}}</marv-message>
                                <marv-button icon="add-outline" [rounded]="true" size="small" (click)="this.showAdditionalsDatasStore()" /> 
                            }    
                        </div>
                    </div>
                }
                
            }
            @else{
                <marv-message id="msg_no_store_selected" type="warning" (click)="this.openStoresDrawer()">{{'MSG_SELECT_STORE' | translate}}</marv-message>
            }
        }

        @if((this.operationPlanningSetting.missionPlanningPurposes && this.operationPlanningSetting.missionPlanningPurposes.length > 0) || this.merchImplementationOptions.length > 0){
            <div class="order_title">
                <marv-section-title label="{{'GOALS' | translate}}" icon="rocket-outline"/>
                <marv-toggle formName="enableGoals" [disabled]="this.disabledForm" [noMargin]="true"/>
            </div>
            @if(this.showMsgSelectPurpose){
                @if(this.operationPlanningSetting.useMultiPurposePlanning){
                    <marv-message type="warning">{{'MSG_SELECT_PURPOSES' | translate}}</marv-message>
                }
                @else{
                    <marv-message type="warning">{{'MSG_SELECT_PURPOSE' | translate}}</marv-message>
                }
            }
            @if(this.addOrderDayForm.controls['enableGoals'].value){
                @if(this.operationPlanningSetting.useMultiPurposePlanning){
                    @for(goal of this.multipleGoals; track $index){
                        <marv-sub-item class="multiple_goal">
                            <div class="multiple_goal_title">
                                <div (click)="this.enableMultipleGoal(goal.id)">{{goal.name}}</div>
                                <marv-toggle [formName]="'enableMultipleGoal_'+goal.id" [disabled]="this.disabledForm" [noMargin]="true"/>
                            </div>
                            @if(this.addOrderDayForm.controls['enableMultipleGoal_'+goal.id].value){
                                <div>
                                    <marv-textarea 
                                        label="{{ 'COMMENTS' | translate }}" 
                                        icon="information-circle-outline" 
                                        [formName]="'multipleGoalComments_'+goal.id" 
                                        [fixedLabel]="true" 
                                        [withSpeechToText]="true"
                                        [disabled]="this.disabledForm"
                                        />
                                </div>
                            }
                        </marv-sub-item>
                    }
                }
                @else{
                    <marv-select 
                        label="{{ 'GOAL' | translate }}" 
                        icon="rocket-outline" 
                        formName="uniqueGoal" 
                        [items]="this.uniqueGoals" 
                        [withSpeechToText]="true"
                        [disabled]="this.disabledForm"
                        />
                    
                    <marv-textarea 
                        label="{{ 'COMMENTS' | translate }}" 
                        icon="information-circle-outline" 
                        formName="uniqueGoalComments" 
                        [fixedLabel]="true" 
                        [withSpeechToText]="true"
                        [disabled]="this.disabledForm"
                        />
                }
                
                @if(this.merchImplementationOptions.length > 0){
                    <marv-select 
                        label="{{ 'ELEMENTS_MERCH' | translate }}" 
                        icon="construct-outline" 
                        formName="merchImplementationOption" 
                        [items]="this.merchImplementationOptions" 
                        [withSpeechToText]="true"
                        [disabled]="this.disabledForm || this.disabledUpdate"
                        />
                }
            }
        }
        
        <div class="order_title">
            <marv-section-title label="{{'DATES' | translate}}" icon="calendar-outline"/>
            @if(this.addOrderDayForm.controls['enableRecurrence'].value){
            <marv-circle id="btn_dates_preview" size="small" (click)="this.openDatesPreviewModal()" [color]="(this.datesPreview.finalDates.length > 0 ? 'green' : 'secondary')">{{this.datesPreview.finalDates.length}}</marv-circle>
            }
            @if(!this.disabledUpdate && this.operationPlanningSetting.nbOfConsecutivePlannedDays < 2){
                <marv-toggle label="{{ 'RECURRENCE' | translate }}" formName="enableRecurrence" [disabled]="this.disabledForm" [noMargin]="true"/>
            }
        </div>
        
        @if(this.dayOrderDurationEstimatedStr !== ''){
            <marv-message type="success" icon="alert-circle-outline">{{'MSG_DAY_ORDER_DURATION_ESTIMATED' | translate}} : <b>{{this.dayOrderDurationEstimatedStr}}</b></marv-message>
        }
        
        @if(this.planningComplientReport!=null && this.planningComplientReport.complianceInfringements.length > 0){
            @for(message of this.planningComplientReport.complianceInfringements; track $index){
                <marv-message type="error">{{message}}</marv-message>
            }
        }
        
        @if(this.planningComplientReport!=null && this.planningComplientReport.compliancWarnings.length > 0){
            @for(message of this.planningComplientReport.compliancWarnings; track $index){
                <marv-message type="warning">{{message}}</marv-message>
            }
        }
                
        <marv-select 
            label="{{ 'NB_DAYS_MISSIONS' | translate }}" 
            icon="construct-outline" 
            formName="nbDays" 
            [items]="this.days" 
            [withSearch]="false" 
            [disabled]="this.disabledForm || this.disabledUpdate || this.operationPlanningSetting.nbOfConsecutivePlannedDays > 1"
            />
                
        @for(numDate of this.numsDates; track $index){
            <div class="order_day_date"
                [class.with_border]="this.numsDates.length > 1">
                @if(this.numsDates.length > 1){
                    <div class="order_day_date_label"><span>{{'DAY' | translate}}&nbsp;</span><b>{{numDate}}</b></div>
                }
                
                @if(this.addOrderDayForm.controls['enableRecurrence'].value){
                    <marv-input-date 
                        label="{{ 'START_DATE' | translate }}" 
                        [formName]="'recurrence_start_date_'+numDate" 
                        [isDateEnabled]="this.isDateEnabled" 
                        [highlightedDates]="this.isHighlightedDates"
                        [withSpeechToText]="true" 
                        [disabled]="this.disabledForm"
                        class="field_date"
                        />       
                    
                    <marv-input-date 
                        label="{{ 'END_DATE' | translate }}" 
                        [formName]="'recurrence_end_date_'+numDate" 
                        [isDateEnabled]="this.isDateEnabled" 
                        [highlightedDates]="this.isHighlightedDates"
                        [withSpeechToText]="true" 
                        [disabled]="this.disabledForm"
                        class="field_date"
                        /> 
                    
                    <marv-select 
                        label="{{ 'PERIODICITY' | translate }}" 
                        icon="sync-outline" 
                        [formName]="'periodicity_'+numDate" 
                        [items]="this.periodicityRecurrence" 
                        [withSearch]="false" 
                        [disabled]="this.disabledForm"
                        class="field_full"
                        />
                    
                    @switch (this.addOrderDayForm.controls['periodicity_'+numDate].value) {
                        @case (1) {
                            <div class="weekly_recurrence">
                                <div class="weekly_recurrence_value">
                                    {{ 'PERIODICITY_EVERY' | translate }}
                                    <marv-input 
                                        type="number" 
                                        [formName]="'weekly_recurrence_'+numDate" 
                                        [disabled]="this.disabledForm"
                                        class="field_periodicity_week"
                                        />
                                    {{ 'PERIODICITY_WEEKS' | translate }}
                                </div>
                                <div class="weekly_days">
                                    @for(wd of this.weekDays; track $index){
                                        <marv-checkbox 
                                            [label]="wd.name" 
                                            [formName]="'weekly_day_'+numDate+'_'+wd.numDay" 
                                            [inline]="true" 
                                            [disabled]="this.disabledForm"
                                            labelPlacement="end"
                                            /> 
                                    }
                                </div>
                            </div>
                        }
                        @case (2) {                            
                            <div class="monthly_recurrence"> 
                                {{ 'THE' | translate }}
                                <marv-select 
                                    [formName]="'monthly_recurrence_day_num_'+numDate" 
                                    [items]="this.recurrenceMonthDay" 
                                    [disabled]="this.disabledForm"
                                    [withSearch]="false" 
                                    />                                
                                <marv-select 
                                    [formName]="'monthly_recurrence_day_'+numDate" 
                                    [items]="this.weekDaysItems" 
                                    [disabled]="this.disabledForm"
                                    [withSearch]="false" 
                                    />                                
                                {{ 'PERIODICITY_EVERY_MONTH' | translate }}
                                <marv-input 
                                    type="number" 
                                    [formName]="'monthly_recurrence_month_'+numDate" 
                                    [disabled]="this.disabledForm"                                   
                                    />
                                {{ 'MONTH' | translate }}                               
                            </div>
                        }
                    }
                    
                }
                @else{
                    <marv-input-date 
                        label="{{ 'ORDER_DAY' | translate }}" 
                        [formName]="'day_'+numDate" 
                        [isDateEnabled]="this.isDateEnabled" 
                        [highlightedDates]="this.isHighlightedDates"
                        [fixedLabel]="true" 
                        [withSpeechToText]="true" 
                        [disabled]="this.disabledForm"     
                        class="field_full"
                        />       
                }
                
                @if(this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM && !this.disabledForm && !this.disabledUpdate){
                    <!-- Merch & Toursolver -->
                    <!--
                    <div class="buttons_select_hours_entry">
                        <div class="button_select_hours_entry" [class.selected]="this.hoursEntrySelected.get(numDate) === 'IMPOSED'" (click)="this.selectHoursEntry(numDate, 'IMPOSED')">{{'HOURS_IMPOSED' | translate}}</div>
                        <div class="button_select_hours_entry" [class.selected]="this.hoursEntrySelected.get(numDate) === 'SUGGESTED'" (click)="this.selectHoursEntry(numDate, 'SUGGESTED')">{{'HOURS_SUGGESTED' | translate}}</div>
                    </div>
                    -->
                }
                
                <input type="hidden" [name]="'hoursEntry_'+numDate" [formControlName]="'hoursEntry_'+numDate"/>
                
                <marv-input-time 
                    label="{{ 'START_TIME_MIN' | translate }}" 
                    icon="time-outline" 
                    [formName]="'startTimeMin_'+numDate" 
                    [fixedLabel]="true" 
                    [disabled]="this.disabledForm || this.operationPlanningSetting.hasTimeFix()" 
                    class="field_time"
                    [class.hide_field]="(this.operation.typeOfMission.code === environment.MISSION_TYPE_ANIM || this.hoursEntrySelected.get(numDate) === 'IMPOSED')"
                    />
                
                <marv-input-time 
                    label="{{ 'START_TIME_MAX' | translate }}" 
                    icon="time-outline" 
                    [formName]="'startTimeMax_'+numDate" 
                    [fixedLabel]="true" 
                    [disabled]="this.disabledForm || this.operationPlanningSetting.hasTimeFix()" 
                    class="field_time"
                    [class.hide_field]="(this.operation.typeOfMission.code === environment.MISSION_TYPE_ANIM || this.hoursEntrySelected.get(numDate) === 'IMPOSED')"
                    />
                
                <marv-input-time 
                    label="{{ 'MORNING_ORDER' | translate }}" 
                    icon="time-outline" 
                    [formName]="'timeMorning_'+numDate" 
                    [fixedLabel]="true" 
                    [disabled]="this.disabledForm || this.operationPlanningSetting.hasTimeFix()" 
                    class="field_time"
                    [class.hide_field]="this.operationPlanningSetting.hasTimeFix() || (this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM && this.hoursEntrySelected.get(numDate) === 'SUGGESTED')"
                    />
                     
                <div class="field_time">
                    <marv-select 
                        label="{{ 'DURATION_ORDER' | translate }}" 
                        icon="hourglass-outline" 
                        [formName]="'durationMorning_'+numDate" 
                        [items]="this.durations" 
                        [withSearch]="false" 
                        [disabled]="this.disabledForm || this.operationPlanningSetting.hasTimeFix() || this.enforceDayOrderDurationEstimated || this.enforceDayOrderDuration"                         
                        [class.hide_field]="this.operationPlanningSetting.hasTimeFix()"
                        />
                    @if(this.hoursEntrySelected.get(numDate) === 'SUGGESTED' && this.dayOrderEndHourEstimatedStr !== ''){
                        <div class="msg_end_hour_estimated">
                            <small>{{this.dayOrderEndHourEstimatedStr}}</small>
                        </div>
                    }
                </div>
                
                <marv-input-time 
                    label="{{ 'AFTERNOON_ORDER' | translate }}" 
                    icon="time-outline" 
                    [formName]="'timeAfternoon_'+numDate" 
                    [fixedLabel]="true" 
                    [disabled]="this.disabledForm || this.operationPlanningSetting.hasTimeFix()" 
                    class="field_time"
                    [class.hide_field]="this.operationPlanningSetting.hasTimeFix() || this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM"
                    />
                
                <marv-select 
                    label="{{ 'DURATION_ORDER' | translate }}" 
                    icon="hourglass-outline" 
                    [formName]="'durationAfternoon_'+numDate" 
                    [items]="this.durations" 
                    [withSearch]="false" 
                    [disabled]="this.disabledForm || this.operationPlanningSetting.hasTimeFix() || this.enforceDayOrderDurationEstimated" 
                    class="field_time"
                    [class.hide_field]="this.operationPlanningSetting.hasTimeFix() || this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM"
                    />   
                
            </div>
        }

        <marv-section-title label="{{'AGENTS' | translate}}" icon="person-outline"/>
        
        @if(this.nbWorkersRecommended > 0){
            <marv-message type="success" icon="alert-circle-outline">{{'MSG_NB_WORKERS_RECOMMENDED' | translate}} : <b>{{this.nbWorkersRecommended}}</b></marv-message>
        }
        
        @if(this.kits.length > 0){
            <marv-select 
                label="{{ 'KIT' | translate }}" 
                icon="construct-outline" 
                formName="kit" 
                [items]="this.kits"
                [disabled]="this.disabledForm"
                />
        }
        
        <marv-input 
            type="number" 
            label="{{ 'NB_AGENTS' | translate }}" 
            icon="people-outline" 
            formName="nbAgents" 
            [min]="1"
            [max]="10"
            [withSpeechToText]="true" 
            [disabled]="this.disabledForm ||this.disabledUpdate"
            errorText="{{ 'MSG_NB_AGENTS_ERROR' | translate }}"
            />
        @for(numAgent of this.numsAgents; track $index){
            <div class="order_day_agent">
                <div class="order_day_agent_label"><span>{{'AGENT' | translate}}&nbsp;</span><b>{{numAgent}}</b></div>
                <div class="order_day_agent_inputs" [class.with_suggestions]="(this.showWorkersSuggestionList && this.workersSuggestionItem.length > 0)">
                    <marv-select 
                        class="order_day_agent_profil"
                        label="{{ 'AGENT_PROFIL' | translate }}" 
                        icon="person-outline" 
                        [formName]="'agentProfil_'+numAgent" 
                        [items]="this.agentsProfils" 
                        [withSpeechToText]="true"
                        [disabled]="this.disabledForm"
                        />
                  
                    <marv-select 
                        class="order_day_agent_suggestions"
                        [class.hide_field]="(!this.showWorkersSuggestionList || this.workersSuggestionItem.length === 0)"
                        label="{{ 'SUGGESTIONS' | translate }}" 
                        icon="person-outline" 
                        [formName]="'agentsSuggestionIds_'+numAgent" 
                        [items]="this.workersSuggestionItem"
                        [messageInfo]="this.workersSuggestionMessageInfo"
                        [multiple]="true"
                        [disabled]="this.disabledForm"
                        />
                    
                    <marv-input 
                        type="text" 
                        class="order_day_agent_free_suggestion"
                        [label]="(this.showWorkersSuggestionList && this.workersSuggestionItem.length > 0 ? this.translateService.instant('OTHER_SUGGESTION') : this.translateService.instant('SUGGESTION'))" 
                        icon="person-outline" 
                        [formName]="'agentSuggestion_'+numAgent" 
                        [withSpeechToText]="true"
                        [disabled]="this.disabledForm"
                        />
                </div>
            </div>
        }

        <div class="order_title">
            <marv-section-title label="{{'MISSION_BRIEF' | translate}}" icon="information-circle-outline"/>
            <marv-toggle formName="enableMissionBrief" [disabled]="this.disabledForm" [noMargin]="true"/>
        </div>
        @if(this.addOrderDayForm.controls['enableMissionBrief'].value){            
            <marv-input-file                
                label="{{ 'MISSION_BRIEF_FILE' | translate }}" 
                icon="document-outline" 
                formName="missionDetailsFile" 
                [(file)]="this.missionDetailsFile" 
                [fixedLabel]="true" 
                [acceptFiles]="this.missionDetailsFileExt" 
                [showBtnClearInput]="true"
                [disabled]="this.disabledForm"
                />
        }

        @if(this.operation?.typeOfMission?.code != this.environment.MISSION_TYPE_ANIM){
            <div class="order_title">
                <marv-section-title label="{{'STORE_CONTACT_INFOS' | translate}}" icon="information-circle-outline"/>            
                <marv-toggle formName="enableStoreContact" [disabled]="this.disabledForm" [noMargin]="true"/>
            </div>
            @if(this.addOrderDayForm.controls['enableStoreContact'].value){
                <marv-input 
                    type="text" 
                    label="{{ 'CONTACT' | translate }}" 
                    icon="person-outline" 
                    formName="storeContactName" 
                    [withSpeechToText]="true" 
                    [disabled]="this.disabledForm"
                    class="field_store_contact"
                    />
                <marv-input 
                    type="text" 
                    label="{{ 'PHONE' | translate }}" 
                    icon="call-outline" 
                    formName="storeContactPhone" 
                    [withSpeechToText]="true" 
                    [disabled]="this.disabledForm"
                    class="field_store_contact"
                    />
                <marv-input 
                    type="text" 
                    label="{{ 'STORE_ACCESS' | translate }}" 
                    icon="location-outline" 
                    formName="storeContactAccess" 
                    [withSpeechToText]="true"
                    [disabled]="this.disabledForm"
                    />
            }
        }

        @if(this.operation?.typeOfMission?.code != this.environment.MISSION_TYPE_ANIM){
            <div class="order_title">
                <marv-section-title label="{{'CUSTOMER_APPOINTMENT' | translate}}" icon="person-outline"/>
                <marv-toggle formName="enableCustomerAppointment" [disabled]="this.disabledForm" [noMargin]="true"/>
            </div>
            @if(this.addOrderDayForm.controls['enableCustomerAppointment'].value){
                @if(this.contactSharingToWorkerAllowed){
                    <marv-toggle label="{{ 'SHARE_CONTACT_TO_WORKER' | translate }}" labelPlacement="end" formName="sharingCustomerSectorContactDetailsToWorker" [disabled]="this.disabledForm"/>
                }
                <marv-input 
                    type="text" 
                    label="{{ 'APPOINTMENT_PLACE' | translate }}" 
                    icon="location-outline" 
                    formName="customerAppointmentPlace" 
                    [withSpeechToText]="true" 
                    [disabled]="this.disabledForm"
                    id="field_customer_appointment_place"
                    />
                <marv-input-time 
                    label="{{ 'APPOINTMENT_HOUR' | translate }}" 
                    icon="time-outline" 
                    formName="customerAppointmentTime" 
                    [withSpeechToText]="true" 
                    [disabled]="this.disabledForm"
                    id="field_customer_appointment_time"
                    />
            }
        }
    </div>      
    <ion-grid id="footer_add_order_day">
        <ion-row class="ion-justify-content-around">
            @if(this.disabledForm){
                <ion-col size="auto">
                    <marv-button 
                        type="button" 
                        label="{{ 'CLOSE' | translate }}" 
                        icon="close-outline" 
                        color="secondary" 
                        (click)="this.cancelAddDayOrder()" 
                        />
                </ion-col>
            }
            @else{
                @if(this.isLoggedUserAllowedToPlan){
                    <ion-col size="auto">
                        <marv-button 
                            type="submit" 
                            label="{{ 'VALIDATE' | translate }}" 
                            icon="checkmark-outline" 
                            color="primary" 
                            [isFetching]="this.isFetchingSave" 
                            [disabled]="this.disabledForm || this.isDisabledValidate()"
                            />
                    </ion-col>
                }
                <ion-col size="auto">
                    <marv-button 
                        type="button" 
                        label="{{ 'CANCEL' | translate }}" 
                        icon="close-outline" 
                        color="secondary" 
                        (click)="this.cancelAddDayOrder()" 
                        />
                </ion-col>
            }
        </ion-row>
    </ion-grid>

</form>